import { loginStatus } from 'utils/constants/status';
import get from 'lodash/get';
import find from 'lodash/find';
import { getPersonName } from 'utils/details';
import { matchedQualificationDate } from 'utils/assetHelper';
import isEmpty from 'lodash/isEmpty';

export const ASSET_STATUS = {
  AVAILABLE: { id: 'AVAILABLE', name: 'Available' },
  DEPLOYING: { id: 'DEPLOYING', name: 'Deploying' },
  IN_USE: { id: 'IN_USE', name: 'In Use' },
  RETURNING: { id: 'RETURNING', name: 'Returning' },
  UNAVAILABLE: { id: 'UNAVAILABLE', name: 'Unavailable' },
  UNREGISTERED: { id: 'UNREGISTERED', name: 'Unregistered' },
};

const acceptedPersonnelStatus = [
  loginStatus.AVAILABLE,
  loginStatus.ON_INTERRUPTABLE_TASK,
];
//return all personnel whose status is AVAILABLE/ON_INTERRUPTABLE_TASK
export const getPersonnelByStatus = personnelData => {
  return personnelData.filter(personnel =>
    acceptedPersonnelStatus.includes(personnel.value.operational.status),
  );
};
export const getMatchedQualifications = (personnel, assetTypeName) => {
  const qualifications = get(personnel, 'qualifications');
  const matchedQualification = qualifications.find(
    data => data.typeName === assetTypeName,
  );
  return matchedQualification;
};
export const getAssetReceiverInfo = (personnelData, currentAssigness) => {
  const receiver = personnelData.find(
    assignee => assignee.value.general.id === currentAssigness.id,
  );
  return get(receiver, 'value');
};
export const checkQualificationForNullOrEmpty = personnelData => {
  return personnelData.filter(
    personnel =>
      personnel.details.qualifications !== null &&
      personnel.details.qualifications.length > 0,
  );
};

export const getAssetAssignee = (personnelData, assetDetail) => {
  if (isEmpty(assetDetail)) {
    return [];
  }
  /**
   * rule to select the asset assignees :
   * if the asset does not require qualification, then select all the personnel who is AVAILABLE/ON_INTERRUPTABLE_TASK
   * else select all the personnel who has the selected asset qualification
   */
  if (assetDetail.type.qualificationRequired) {
    const PersonnelWithQualificationValue = checkQualificationForNullOrEmpty(
      personnelData,
    );
    return PersonnelWithQualificationValue.reduce(
      (assetAssignee, personnel) => {
        const matchedQualificationData = getMatchedQualifications(
          personnel.details,
          assetDetail.type.name,
        );
        if (
          matchedQualificationData &&
          matchedQualificationDate(matchedQualificationData)
        ) {
          assetAssignee.push({
            id: personnel.general.id,
            label: getPersonName(personnel.general),
          });
        }
        return assetAssignee;
      },
      [],
    );
  } else {
    return personnelData.map(personnel => ({
      id: personnel.general.id,
      label: getPersonName(personnel.general),
    }));
  }
};
export const getAssetReceiverData = (personnel, id) => {
  const receiverData = find(personnel, ['general.id', id]);
  return receiverData;
};
export const operatorOptions = [
  { id: 'GREATER_THAN', name: '>' },
  { id: 'GREATER_THAN_OR_EQUAL', name: '>=' },
  { id: 'LESS_THAN', name: '<' },
  { id: 'LESS_THAN_OR_EQUAL', name: '<=' },
  { id: 'EQUAL', name: '=' },
];
